import VSelectStore from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectStore', VSelectStore),
};
